import { landingPageConstants } from "../action-types";

const initialState = {
    metricLoading: true,
    metricError: false,
    metricData: {},

    pendingsLoading: true,
    pendingsError: false,
    pendingsData: [],
};

const bosLandingReducer = (state = initialState, action) => {
  switch (action.type) {
    case landingPageConstants.GET_BOS_METRICS_LOADING:{
        return {
            ...state,
            metricLoading:true,
            metricError: false
        }
    }
    case landingPageConstants.GET_BOS_METRICS_ERROR:{
        return {
            ...state,
            metricLoading: false,
            metricError: true
        }
    }
    case landingPageConstants.GET_BOS_METRICS_DATA: {
        return {
            ...state,
            metricLoading: false,
            metricError: false,
            metricData: action.metricData
        };
    }
    case landingPageConstants.GET_BOS_PENDINGS_LOADING:{
        return {
            ...state,
            pendingsLoading:true,
            pendingsError: false
        }
    }
    case landingPageConstants.GET_BOS_PENDINGS_ERROR:{
        return {
            ...state,
            pendingsLoading: false,
            pendingsError: true
        }
    }
    case landingPageConstants.GET_BOS_PENDINGS_DATA: {
        return {
            ...state,
            pendingsLoading: false,
            pendingsError: false,
            pendingsData: action.pendingsData
        };
    }

    default:
      return state;
  }
};

export { bosLandingReducer };
